/**
 * Split an EIP-712 signature into r, s, v components
 */
export function splitSignature(signature: `0x${string}`): {
  r: `0x${string}`;
  s: `0x${string}`;
  v: number;
} {
  if (!signature.startsWith('0x')) {
    throw new Error('Signature must start with 0x');
  }

  if (signature.length !== 132) {
    throw new Error('Invalid signature length');
  }

  const r = `0x${signature.slice(2, 66)}` as `0x${string}`;
  const s = `0x${signature.slice(66, 130)}` as `0x${string}`;
  const v = parseInt(signature.slice(130, 132), 16);

  return { r, s, v };
}

/**
 * Validate a hex signature
 */
export function isValidSignature(signature: string): boolean {
  return /^0x[0-9a-fA-F]{130}$/.test(signature);
}
